import type { Store } from "@/store/index";

export function parsePreloadStateToBootstrap(preloadState: string) {
  const decoded = atob(preloadState);
  return JSON.parse(decoded);
}

export function removePreloadObject() {
  const bootstrapScript = document.getElementById("nw-bootstrap");

  if (bootstrapScript) {
    bootstrapScript.remove();
  }
}

export function exposeStoreToWindow(store: Store) {
  window.nw_store = store;
}
